import React, { useState, useEffect } from 'react';
import { Input, Button, useToaster, Notification } from 'rsuite';
import {SharedApi} from "../../../../../../services/Shared.api";

const MechanismPrivateDescriptionSection = ({
  mechanismId,
  isMechanismMovement,
  isConnected = true,
  privateDescription: initialPrivateDescription = ''
}) => {
  const [privateDescription, setPrivateDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const toaster = useToaster();

  const message = (
    <Notification type={"success"} closable>
      <p>Данные записаны</p>
    </Notification>
  );

  useEffect(() => {
    setPrivateDescription(initialPrivateDescription || '');
  }, [initialPrivateDescription, mechanismId]);

  const onSavePrivateDescription = async () => {
    try {
      setLoading(true);
      const result = await SharedApi.updatePrivateDescription(mechanismId, privateDescription);

      if (result) {
        toaster.push(message, { placement: "topEnd" });
      }
    } catch (e) {
      console.error('Ошибка сохранения:', e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="section mb-3" style={{
      opacity: !isConnected ? 1 : (isMechanismMovement() ? 0.5 : 1)
    }}>
      <div className="row">
        <div className="col-md-12">
          <Input
            style={{ borderRadius: 0 }}
            as="textarea"
            rows={3}
            value={privateDescription}
            onChange={setPrivateDescription}
            placeholder="Поле с описанием как настроена система боя или описываются иные моменты подключений!"
          />
        </div>
      </div>
      <div className="row pe-2 mt-2 mb-2">
        <div className="col-md-12 text-end">
          <Button
            onClick={onSavePrivateDescription}
            loading={loading}
            className="channel-save-btn">
            Сохранить
          </Button>
        </div>
      </div>
    </section>
  );
};

export default MechanismPrivateDescriptionSection;
